import type { ActivationStore } from './interfaces'

import { ShortDaysOfWeek } from '@brighterly/lib-core-types/options/enums'
import { StartDateType, Step } from '@brighterly/lib-core-types/activation/enums'
import { Stage } from '@brighterly/lib-core-types/discipline/enums'

import { getInitialScheduleData } from '../../lib/schedule'

export const createInitialState = (): ActivationStore => ({
  processing: false,
  dayOfWeek: ShortDaysOfWeek.Sunday,
  schedule: getInitialScheduleData(),
  startDate: '',
  tutorType: null,
  draftStepSchedule: null,
  draftStepStartDate: null,
  draftStepPersonalization: null,
  draftStepTutorType: false,
  switcherStartDateType: StartDateType.Soon,
  validSchedule: true,
  expectations: [],
  activationReminders: [],
  screenRecording: false,
  stage: Stage.ManualActivation,
  activationStep: Step.StartDate,
  homeStep: Step.StartDate,
  modalDiscardActivation: false,
  activationCompleted: false,
  modalBonus: false,
  bookingAvailableDays: null,
  bookingDate: null,
  bookingTime: null,
  triggerBookingSelect: 0,
  availableTimes: null,
  availableSlots: null,
  availableDays: null,
  modalBooked: false,
  modalPremiumTutorRetry: false,
  preferences: '',
  optionsLoading: false,
  premiumTutorUpsellOrder: null,
  activationOrderIdQuery: null,
})
